import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Table, Thead, Tbody, Th, Tr, Td } from "../elements/Table";
import {
  Heading,
  Anchor,
  Icon,
  Box,
  Text,
  Input,
  Image,
  Button,
} from "../elements";
import { handleAlert } from "../../functions/handleAlert";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { getOrdersList } from "../../store/ordersListSlice";
import { getOrderCounter } from "../../store/orderCounterSlice";
import { getFormsList } from "../../store/formsListSlice";

export default function FormsTable({ thead, tbody }) {
  const [alertModal, setAlertModal] = React.useState(false);
  const [data, setData] = useState([]);
  const [orderId, setOrderId] = useState(null);
  const { token } = useSelector((state) => state.auth);
  const dispatch = useDispatch();




  const handleCheckbox = (event) => {
    const { name, checked } = event.target;

    if (name === "allCheck") {
      const checkData = data?.map((item) => {
        return { ...item, isChecked: checked };
      });
      setData(checkData);
    } else {
      const checkData = data?.map((item) =>
        item.name === name ? { ...item, isChecked: checked } : item,
      );
      setData(checkData);
    }
  };

  const handleDeleteOrder = async () => {
    await axios.delete(`${process.env.REACT_APP_SERVER_URL}/order/${orderId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then((res) => {
      // dispatch(getProductsList())
      // dispatch(getProductsCounter())
      dispatch(getOrdersList())
      dispatch(getFormsList())
      dispatch(getOrderCounter())
      handleAlert(res.data.message, "success")
    }).catch((err) => {
      handleAlert(err.response.data.message, "error")
    })
    setAlertModal(false)
  }

  useEffect(() => {
    setData(tbody);
  }, [tbody]);

  return (
    <Box className="mc-table-responsive">
      <Table className="mc-table">
        <Thead className="mc-table-head primary">
          <Tr>
            <Th>
              <Box className="mc-table-check">
                {/* <Input
                  type="checkbox"
                  name="allCheck"
                  checked={
                    data?.filter((item) => item.isChecked !== true).length < 1
                  }
                  onChange={handleCheckbox}
                /> */}
                <Text>uid</Text>
              </Box>
            </Th>
            {thead.map((item, index) => (
              <Th key={index}>{item}</Th>
            ))}
          </Tr>
        </Thead>
        <Tbody className="mc-table-body even">
          {/* {data?.map((item, index) => (
            <Tr key={index}>
              <Td>
                <Box className="mc-table-check">
                  <Input
                    type="checkbox"
                    name={item.name}
                    checked={item?.isChecked || false}
                    onChange={handleCheckbox}
                  />
                  <Text>{item.id}</Text>
                </Box>
              </Td>
              <Td>
                <Box className="mc-table-profile">
                  <Image src={item.src} alt={item.alt} />
                  <Text>{item.name}</Text>
                </Box>
              </Td>
              <Td>{item.email}</Td>
              <Td>{item.amount}</Td>
              <Td>
                <Text className={`mc-table-badge ${item.status.variant}`}>
                  {item.status.text}
                </Text>
              </Td>
              <Td>{item.date}</Td>
              <Td>
                <Box className="mc-table-action">
                  <Anchor
                    title="View"
                    href="/invoice-details"
                    className="material-icons view"
                  >
                    {item.action.view}
                  </Anchor>
                  <Anchor
                    title="Download"
                    href="#"
                    className="material-icons download"
                    download
                  >
                    {item.action.download}
                  </Anchor>
                  <Button
                    title="Delete"
                    className="material-icons delete"
                    onClick={() => setAlertModal(true)}
                  >
                    {item.action.delete}
                  </Button>
                </Box>
              </Td>
            </Tr>
          ))} */}
          {tbody && tbody?.map((item, index) => (
            <Tr key={index}>
              <Td title={index + 1}>
                {/* <Box className="mc-table-check">
                  <Text>#{index + 1}</Text>
                </Box> */}
                <Box className="mc-table-check">
                  {/* <Input
                    type="checkbox"
                    name={item.name}
                    checked={item?.isChecked || false}
                    onChange={handleCheckbox}
                  /> */}
                  <Text>#{index + 1}</Text>
                </Box>
              </Td>
              <Td>
                <Box className="mc-table-product md">
                  {/* <Image src={`${process.env.REACT_APP_SERVER_URL}/${item.image}`} alt={"Cover"} /> */}
                  <Box className="mc-table-group">
                    <Heading as="h6">{item.name}</Heading>
                    {/* <Text>{item.description}</Text> */}
                  </Box>
                </Box>
              </Td>

              <Td>{item.product}</Td>
              <Td>
                <Box className="mc-table-price">
                  <Text>{item.phone}</Text>
                </Box>
              </Td>
              <Td>{item.email}</Td>
              <Td>
                {/* اعمل كلاس بأسم كل استاتيس وظبط الاستايل بتاعوا  */}
                <Text className={`mc-table-badge ${item.status}`}>
                  {item.status}
                </Text>
                {/* <Text className={`mc-table-badge ${(item.status == "pending")?`purple`:''}`}>
                  {item.status}
                </Text> */}
              </Td>
              {/* <Td>
              {item.status}
              </Td> */}
              <Td>
                <Box className="mc-table-rating">
                  <Heading>{item.createdAt.split('T')[0]}</Heading>
                </Box>
              </Td>
              <Td>
                <Box className="mc-table-rating">
                  <Heading>{item.category}</Heading>
                </Box>
              </Td>
              <Td>
                <Box className="mc-table-action">
                  <Anchor
                    href={`/order-view?id=${item._id}`}
                    title="View"
                    className="material-icons view"
                  >
                    visibility
                  </Anchor>
                  {/* <Button
                    title="Discount"
                    className="material-icons discount"
                    onClick={() => {setCouponedModal(true);setProductId(item._id)}}
                  >
                    discount
                  </Button> 
                  <Anchor
                    href={`/brand-edit?id=${item._id}`}
                    title="Edit"
                    className="material-icons  edit"
                  >
                    edit
                  </Anchor>*/}
                  <Button
                    title="Delete"
                    className="material-icons delete"
                    onClick={() => { setAlertModal(true); setOrderId(item._id) }}
                  >
                    delete
                  </Button>
                </Box>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
      <Modal show={alertModal} onHide={() => setAlertModal(false)}>
        <Box className="mc-alert-modal">
          <Icon type="new_releases" />
          <Heading as="h3">are your sure!</Heading>
          <Text as="p">Want to delete this invoice?</Text>
          <Modal.Footer>
            <Button
              type="button"
              className="btn btn-secondary"
              onClick={() => setAlertModal(false)}
            >
              nop, close
            </Button>
            <Button
              type="button"
              className="btn btn-danger"
              onClick={handleDeleteOrder}
            >
              yes, delete
            </Button>
          </Modal.Footer>
        </Box>
      </Modal>
    </Box>
  );
}
